import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.main');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.main/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class LayoutMainComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init(this);
    }
}

export default LayoutMainComponent;